import { render, staticRenderFns } from "./CertificateShare.vue?vue&type=template&id=7c206ada&scoped=true&"
import script from "./CertificateShare.vue?vue&type=script&lang=js&"
export * from "./CertificateShare.vue?vue&type=script&lang=js&"
import style0 from "./CertificateShare.vue?vue&type=style&index=0&id=7c206ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c206ada",
  null
  
)

export default component.exports